import React, { useState, forwardRef, useImperativeHandle } from "react";

const Toast = forwardRef((props, ref) => {
    const [toasts, setToasts] = useState([]);

    // Add a new toast
    const addToast = (message, type, duration = 3000) => {
        const newToast = { id: Date.now(), message, type };
        setToasts((prev) => [...prev, newToast]);

        // Remove the toast after the specified duration
        setTimeout(() => removeToast(newToast.id), duration);
    };

    // Remove a toast by ID
    const removeToast = (id) => {
        setToasts((prev) => prev.filter((toast) => toast.id !== id));
    };

    // Expose `addToast` method to parent components via ref
    useImperativeHandle(ref, () => ({
        addToast,
    }));

    return (
        <div className="toast-container" aria-live="polite">
            {toasts.map((toast) => (
                <div
                    key={toast.id}
                    className={`toast ${toast.type}`}
                    role="alert"
                >
                    <span>{toast.message}</span>
                    <span
                        className="close-btn"
                        onClick={() => removeToast(toast.id)}
                    >
                        ✖
                    </span>
                </div>
            ))}
        </div>
    );
});

export default Toast;
